(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Some mobile browsers (notably iOS Safari) don't reliably honor the
  // `autoplay` attribute alone for background videos, particularly on
  // constrained connections. Force playback explicitly as a fallback.
  const startHeroVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;

    // Some browsers check the live `muted` property (not just the initial
    // HTML attribute) at the moment `play()` is called before allowing
    // autoplay without a user gesture.
    video.muted = true;

    // If autoplay ends up blocked at the OS level (e.g. iOS Low Power Mode),
    // there's no JS way to force playback and no reliable way to detect the
    // cause. Instead, detect the failure itself and hide the video so the
    // fallback image underneath shows a clean still image, rather than a
    // paused video with a native "tap to play" glyph we can't style away.
    const markBlocked = () => {
      if (video.paused) video.classList.add('is-autoplay-blocked');
    };
    video.addEventListener('playing', () => video.classList.remove('is-autoplay-blocked'));
    video.play().then(markBlocked, markBlocked);
    setTimeout(markBlocked, 1000);
  };

  document.querySelectorAll('.hero__media[autoplay]').forEach(startHeroVideo);

  // Videos with a static fallback image skip native autoplay/preload
  // entirely (marked `.hero__media--deferred`), so their bytes never compete
  // with the hero image (the LCP element) on the critical rendering path.
  // Start loading/playing them only once the page has finished loading.
  const deferredHeroVideos = document.querySelectorAll('.hero__media--deferred');
  if (deferredHeroVideos.length) {
    const loadDeferredHeroVideos = () => deferredHeroVideos.forEach(startHeroVideo);
    if (document.readyState === 'complete') {
      loadDeferredHeroVideos();
    } else {
      window.addEventListener('load', loadDeferredHeroVideos, { once: true });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocatorMap extends HTMLElement {
    connectedCallback() {
      if (typeof L === 'undefined') {
        window.addEventListener('load', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this.map) return;

      const section = this.closest('.section');
      const items = section ? Array.from(section.querySelectorAll('.store-locator__item[data-lat]')) : [];
      const defaultZoom = parseInt(this.dataset.zoom, 10) || 4;
      const markerSize = parseInt(this.dataset.markerSize, 10) || 40;

      this.map = L.map(this, { scrollWheelZoom: false }).setView([0, 0], defaultZoom);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
      }).addTo(this.map);

      const bounds = [];
      let switchingPopup = false;
      let openMarker = null;

      const flyHome = () => {
        if (bounds.length > 0) {
          this.map.flyToBounds(bounds, { padding: [40, 40], maxZoom: defaultZoom, duration: 1 });
        }
        items.forEach((other) => other.classList.remove('is-active'));
        openMarker = null;
      };

      // Fires when a popup closes, whether from the "x" button, clicking
      // elsewhere on the map, or switching to another store's popup. Only
      // fly back to the overview in the first two cases.
      this.map.on('popupclose', () => {
        if (switchingPopup) {
          switchingPopup = false;
          return;
        }
        flyHome();
      });

      items.forEach((item) => {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const icon = item.dataset.logo
          ? L.icon({
              iconUrl: item.dataset.logo,
              iconSize: [markerSize, markerSize],
              iconAnchor: [markerSize / 2, markerSize / 2],
              popupAnchor: [0, -markerSize / 2],
              className: 'store-locator__marker-icon',
            })
          : new L.Icon.Default();

        const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
        const marker = L.marker([lat, lng], { icon }).addTo(this.map);
        marker.bindPopup(
          `<div class="store-locator__popup">${
            item.dataset.name ? `<strong>${item.dataset.name}</strong>` : ''
          }${item.dataset.address ? `<span>${item.dataset.address}</span>` : ''}${
            item.dataset.phone ? `<span>${item.dataset.phone}</span>` : ''
          }<a href="${directionsUrl}" target="_blank" rel="noopener">Get directions</a></div>`
        );

        bounds.push([lat, lng]);

        const selectStore = () => {
          if (openMarker && openMarker !== marker) {
            switchingPopup = true;
          }
          openMarker = marker;
          this.map.flyTo([lat, lng], Math.max(defaultZoom, 13), { duration: 1 });
          marker.openPopup();
          items.forEach((other) => other.classList.remove('is-active'));
          item.classList.add('is-active');
        };

        item.addEventListener('click', selectStore);
        marker.on('click', selectStore);
      });

      if (bounds.length > 0) {
        this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: defaultZoom });
      }
    }
  }

  if (!customElements.get('store-locator-map')) {
    customElements.define('store-locator-map', StoreLocatorMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-modal"] && !Shopify.designMode) return;
  try {
    
  (async function () {
    const STORAGE_KEY = 'subscribeModalDismissedUntil';
    // Sagney (Nov 3, 2026): the modal used to open on a timer alone, interrupting
    // visitors who had just arrived from an ad (most mobile ad visits last a few
    // seconds). It now waits for the delay AND a sign of real interest: the visitor
    // has scrolled through half the page, or this is at least their 2nd page view in
    // the session. Never on the cart page, and never over another open dialog.
    const PAGE_VIEWS_KEY = 'sgPageViews';
    const MIN_SCROLL_RATIO = 0.5;

    let pageViews = 1;
    try {
      pageViews = (parseInt(sessionStorage.getItem(PAGE_VIEWS_KEY), 10) || 0) + 1;
      sessionStorage.setItem(PAGE_VIEWS_KEY, String(pageViews));
    } catch (error) {
      // sessionStorage unavailable - count this as a first page view.
    }

    await customElements.whenDefined('dialog-component');

    const modal = document.getElementById('subscribe-modal');
    if (!modal) return;

    const snoozeDays = parseInt(modal.dataset.snoozeDays, 10) || 15;

    const snooze = () => {
      const until = Date.now() + snoozeDays * 24 * 60 * 60 * 1000;
      try {
        localStorage.setItem(STORAGE_KEY, String(until));
      } catch (error) {
        // localStorage unavailable (private browsing, etc.) - ignore.
      }
    };

    modal.addEventListener('dialog:close', snooze);

    // If the page just reloaded after an email signup submission from this
    // modal, show it immediately so the visitor sees the result, instead of
    // making them wait out the delay again.
    if (modal.querySelector('.email-signup__message')) {
      // The native customer form defaults to id="contact_form" and Shopify
      // redirects back to "?customer_posted=true#contact_form" on submit.
      // Clean that up now that we're showing the result in the modal.
      if (window.location.hash || window.location.search) {
        history.replaceState(null, '', window.location.pathname);
      }
      modal.showDialog();
      return;
    }

    if (modal.dataset.template === 'cart') return;

    let dismissedUntil = 0;
    try {
      dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (error) {
      // localStorage unavailable - treat as never dismissed.
    }

    if (Date.now() < dismissedUntil) return;

    const delay = parseInt(modal.dataset.delayMs, 10) || 3000;
    let delayDone = false;
    let shown = false;

    const scrolledEnough = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      return scrollable <= 0 || window.scrollY / scrollable >= MIN_SCROLL_RATIO;
    };

    const anotherDialogOpen = () => !!document.querySelector('dialog[open]:not(#subscribe-modal dialog)');

    const tryShow = () => {
      if (shown || !delayDone) return;
      if (pageViews < 2 && !scrolledEnough()) return;
      if (anotherDialogOpen()) return;
      shown = true;
      window.removeEventListener('scroll', tryShow);
      modal.showDialog();
    };

    window.addEventListener('scroll', tryShow, { passive: true });
    setTimeout(() => {
      delayDone = true;
      tryShow();
    }, delay);
  })();

  } catch(e) { console.error(e); }
})();
})();
